<template>
  <div v-if="false" class="literature-section-wrapper">
    <TeacherLiteratureLibrary />
  </div>
</template>

<script>
import TeacherLiteratureLibrary from "./TeacherLiteratureLibrary.vue"

export default {
  name: "DivWrapperSubsection",
  components: {
    TeacherLiteratureLibrary
  }
}
</script>

<style scoped>
.literature-section-wrapper {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px 0;
  min-height: 1000px;
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
}
</style>
